import React from "react";
import { useHistory } from 'react-router-dom'
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Translate } from "../../../../language";
import TitleSVG from "../../../../utils/components/TitleSVG/TitleSVG";
import { WineryIcon } from "../../../../assets/icons";
import Input from "../../../../utils/components/Input/Input";
import style from "./Winery.module.css";
import Button from "../../../../utils/components/Button/Button";

const validationSchema = Yup.object().shape({
  Nwinery: Yup.string().required("El nombre es requerido"),
  Cwinery: Yup.string().required("La ciudad es requerida"),
  Dwinery: Yup.string().required("El departamento es requerido"),
  /*  Admwinery: Yup.string().required("El correo es requerido"), */
});


export default function CreateWinery({ setdata }) {

  const history = useHistory();

  return (
    <>
      <TitleSVG
        Icon={WineryIcon}
        titleHighlight={Translate("create", "es")}
        title={Translate("winery", "es")}
      />

      <Formik
        initialValues={{
          Nwinery: "",
          Cwinery: "",
          Dwinery: "",
          /* Admwinery: "", */
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          setdata(values);
          history.push('/Admin/Inventory/WineryList');
        }}
      >
        {(props) => (
          <Form className={`${style.form_container}`}>
            <div className={`${style.input_container}`}>
              <label className={`${style.input_label}`}>Nombre Bodega: </label>
              <Input
                className={`${style.input_form}`}
                type="text"
                name="Nwinery"
                placeholder="Nombre de Bodega"
                onChange={props.handleChange}
                value={props.values.Nwinery}
              />
              <br />
              <ErrorMessage name="Nwinery" component="div" />
            </div>
            <div className={`${style.input_container}`}>
              <label className={`${style.input_label}`}>Ciudad: </label>
              <Input
                className={`${style.input_form}`}
                type="text"
                name="Cwinery"
                placeholder="Ciudad"
                onChange={props.handleChange}
                value={props.values.Cwinery}
              />
              <br />
              <ErrorMessage name="Cwinery" component="div" />
            </div>
            <div className={`${style.input_container}`}>
              <label className={`${style.input_label}`}>Departamento: </label>
              <Input
                className={`${style.input_form}`}
                type="text"
                name="Dwinery"
                placeholder="Departamento"
                onChange={props.handleChange}
                value={props.values.Dwinery}
              />
              <br />
              <ErrorMessage name="Dwinery" component="div" />
            </div>
            <Button
              classNameContent={"button-save-verify-account"}
              type="submit"
              text={Translate("create", "es")}
            />
          </Form>
        )}
      </Formik>
    </>
  );
}
